import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Employee from '../../components/Employee'
import List from '../../components/List'
import Phone from '../../components/Phone'
import { Grid, Col } from '../../components/Grid'
import Helmet from '../../components/seo/Helmet'
import Contact from '../../components/Contact'

export default class Home extends Component {
  render () {
    return (
      <div>
        <Helmet {...this.props.helmetProps} />
        <Employee who="all" />

        <Grid>
          <Col>
            <h1>
              Vi programmerer for bedrifter som satser!
            </h1>
            <p>
              Appresso er et utviklingsfirma som er spesialisert på programmering for Web og API-er.
              Vi kan brukes til:
            </p>
            <List>
              <li>
                <Link to="/tjenester#backend">Implementasjon av backend for mobil- og webapplikasjoner</Link>
              </li>
              <li>
                <Link to="/tjenester#frontend">Frontend-utvikling med bla. React</Link>
              </li>
              <li>
                <Link to="/tjenester#integrasjoner">Integrasjoner og API-er</Link>
              </li>
              <li>
                <Link to="/tjenester#driftcloud">Drift og arbeid med Cloud</Link>
              </li>
            </List>
            <p>
              Nøkkeord og spesialkompetanse: Django, React, Python, Heroku, Javascript, AWS.
            </p>
          </Col>
          <Col>
            <p>
              <h1>Medlemssystem / medlemsregister?</h1>
              Vi mener vi leverer landets beste system for håndtering av medlemmer, og som
              brukes av Arbeiderpartiet og AUF.
            </p>
            <p>
              Vil du ta en prat om medlemssystemet vårt?
              Vi vil gjerne gi deg en demo og fortelle nærmere om fordelene med systemet vi har utviklet.
            </p>
            <p>
              Ring <strong>Tor Ivar</strong> på:{' '}
              <a href="tel:+4748261953"><Phone>+47 482 61 953</Phone></a>
            </p>
            <List>
              <li>
                <Link to="/medlemssystem">Les mer om Appresso medlemssystem</Link>
              </li>
            </List>
          </Col>
        </Grid>
        <Contact
        who="tor"
        title="Lurer du på noe?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du du har spørsmål om hva
        Appresso kan levere.
      </Contact>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js